// import React, { useState, useEffect } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import {
//   FiMenu,
//   FiX,
//   FiHome,
//   FiInfo,
//   FiMail,
//   FiBriefcase,
//   FiUsers,
//   FiAward,
//   FiImage,
//   FiStar,
//   FiCpu,
//   FiChevronDown,
//   FiBookOpen,
//   FiGlobe,
// } from "react-icons/fi";

// function Navbar() {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isAboutHovered, setIsAboutHovered] = useState(false);
//   const [isTeamHovered, setIsTeamHovered] = useState(false);
//   const [isUpdatesHovered, setIsUpdatesHovered] = useState(false);
//   const [mobileOpenSections, setMobileOpenSections] = useState({
//     about: false,
//     team: false,
//     updates: false,
//   });
//   const navigate = useNavigate();
//   const location = useLocation();

//   const menuItems = [
//     { name: "Home", path: "/", icon: <FiHome className="w-5 h-5" /> },
//     {
//       name: "Services",
//       path: "/services",
//       icon: <FiBriefcase className="w-5 h-5" />,
//     },
//     { name: "Contact", path: "/contact", icon: <FiMail className="w-5 h-5" /> },
//   ];

//   const aboutSubmenu = [
//     {
//       name: "Company Overview",
//       path: "/about",
//       icon: <FiInfo className="w-4 h-4" />,
//     },
//     {
//       name: "Technology",
//       path: "/technology",
//       icon: <FiCpu className="w-4 h-4" />,
//     },
//     {
//       name: "Testimonials",
//       path: "/testimonials",
//       icon: <FiStar className="w-4 h-4" />,
//     },
//     {
//       name: "Gallery",
//       path: "/gallery",
//       icon: <FiImage className="w-4 h-4" />,
//     },
//   ];

//   const teamSubmenu = [
//     {
//       name: "Management Team",
//       path: "/team/management",
//       icon: <FiUsers className="w-4 h-4" />,
//     },
//     {
//       name: "Consultancy Team",
//       path: "/team/consultancy",
//       icon: <FiUsers className="w-4 h-4" />,
//     },
//     { name: "All Team", path: "/team", icon: <FiUsers className="w-4 h-4" /> },
//   ];

//   const updatesSubmenu = [
//     {
//       name: "Projects",
//       path: "/projects",
//       icon: <FiAward className="w-4 h-4" />,
//     },
//     {
//       name: "News",
//       path: "/news",
//       icon: <FiGlobe className="w-4 h-4" />,
//     },
//     {
//       name: "Blog",
//       path: "/blog",
//       icon: <FiBookOpen className="w-4 h-4" />,
//     },
//   ];

//   const closeAllMenus = () => {
//     setIsMenuOpen(false);
//     setIsAboutHovered(false);
//     setIsTeamHovered(false);
//     setIsUpdatesHovered(false);
//     setMobileOpenSections({
//       about: false,
//       team: false,
//       updates: false,
//     });
//   };

//   const toggleMobileSection = (section) => {
//     setMobileOpenSections((prev) => ({
//       ...prev,
//       [section]: !prev[section],
//     }));
//   };

//   useEffect(() => {
//     closeAllMenus();
//   }, [location]);

//   return (
//     <>
//       <nav className="fixed top-0 w-full z-50 bg-green-900/95 backdrop-blur-lg border-b border-green-700">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex items-center justify-between h-16">
//             {/* Logo */}
//             <motion.div
//               whileHover={{ scale: 1.05 }}
//               className="flex items-center space-x-3 cursor-pointer"
//               onClick={() => navigate("/")}
//             >
//               <div className="w-10 h-10 bg-gradient-to-r from-green-500 to-emerald-500 rounded-xl flex items-center justify-center">
//                 <span className="text-white font-bold text-lg">A</span>
//               </div>
//               <span className="text-white font-bold text-xl bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent">
//                 Arikonsults
//               </span>
//             </motion.div>

//             {/* Desktop Menu */}
//             <div className="hidden md:flex items-center space-x-6">
//               {menuItems.map((item) => (
//                 <Link
//                   key={item.name}
//                   to={item.path}
//                   className="text-gray-300 hover:text-green-400 transition-colors duration-300 font-medium flex items-center space-x-1"
//                 >
//                   {item.icon}
//                   <span>{item.name}</span>
//                 </Link>
//               ))}

//               {/* About Dropdown */}
//               <div
//                 className="relative"
//                 onMouseEnter={() => setIsAboutHovered(true)}
//                 onMouseLeave={() => setIsAboutHovered(false)}
//               >
//                 <button className="text-gray-300 hover:text-green-400 transition-colors duration-300 font-medium flex items-center space-x-1">
//                   <FiInfo className="w-5 h-5" />
//                   <span>About</span>
//                   <FiChevronDown
//                     className={`w-4 h-4 transition-transform duration-200 ${
//                       isAboutHovered ? "rotate-180" : ""
//                     }`}
//                   />
//                 </button>

//                 <AnimatePresence>
//                   {isAboutHovered && (
//                     <motion.div
//                       initial={{ opacity: 0, y: 10 }}
//                       animate={{ opacity: 1, y: 0 }}
//                       exit={{ opacity: 0, y: 10 }}
//                       className="absolute top-full left-0 mt-2 w-56 bg-green-800/95 backdrop-blur-lg rounded-xl shadow-xl border border-green-700 py-2 z-50"
//                     >
//                       {aboutSubmenu.map((item) => (
//                         <Link
//                           key={item.name}
//                           to={item.path}
//                           className="flex items-center space-x-3 px-4 py-3 text-gray-300 hover:text-green-400 hover:bg-green-700/50 transition-colors duration-200"
//                           onClick={closeAllMenus}
//                         >
//                           {item.icon}
//                           <span>{item.name}</span>
//                         </Link>
//                       ))}
//                     </motion.div>
//                   )}
//                 </AnimatePresence>
//               </div>

//               {/* Team Dropdown */}
//               <div
//                 className="relative"
//                 onMouseEnter={() => setIsTeamHovered(true)}
//                 onMouseLeave={() => setIsTeamHovered(false)}
//               >
//                 <button className="text-gray-300 hover:text-green-400 transition-colors duration-300 font-medium flex items-center space-x-1">
//                   <FiUsers className="w-5 h-5" />
//                   <span>Team</span>
//                   <FiChevronDown
//                     className={`w-4 h-4 transition-transform duration-200 ${
//                       isTeamHovered ? "rotate-180" : ""
//                     }`}
//                   />
//                 </button>

//                 <AnimatePresence>
//                   {isTeamHovered && (
//                     <motion.div
//                       initial={{ opacity: 0, y: 10 }}
//                       animate={{ opacity: 1, y: 0 }}
//                       exit={{ opacity: 0, y: 10 }}
//                       className="absolute top-full left-0 mt-2 w-64 bg-green-800/95 backdrop-blur-lg rounded-xl shadow-xl border border-green-700 py-2 z-50"
//                     >
//                       {teamSubmenu.map((item) => (
//                         <Link
//                           key={item.name}
//                           to={item.path}
//                           className="flex items-center space-x-3 px-4 py-3 text-gray-300 hover:text-green-400 hover:bg-green-700/50 transition-colors duration-200"
//                           onClick={closeAllMenus}
//                         >
//                           {item.icon}
//                           <span>{item.name}</span>
//                         </Link>
//                       ))}
//                     </motion.div>
//                   )}
//                 </AnimatePresence>
//               </div>

//               {/* Updates Dropdown */}
//               <div
//                 className="relative"
//                 onMouseEnter={() => setIsUpdatesHovered(true)}
//                 onMouseLeave={() => setIsUpdatesHovered(false)}
//               >
//                 <button className="text-gray-300 hover:text-green-400 transition-colors duration-300 font-medium flex items-center space-x-1">
//                   <FiAward className="w-5 h-5" />
//                   <span>Updates</span>
//                   <FiChevronDown
//                     className={`w-4 h-4 transition-transform duration-200 ${
//                       isUpdatesHovered ? "rotate-180" : ""
//                     }`}
//                   />
//                 </button>

//                 <AnimatePresence>
//                   {isUpdatesHovered && (
//                     <motion.div
//                       initial={{ opacity: 0, y: 10 }}
//                       animate={{ opacity: 1, y: 0 }}
//                       exit={{ opacity: 0, y: 10 }}
//                       className="absolute top-full left-0 mt-2 w-56 bg-green-800/95 backdrop-blur-lg rounded-xl shadow-xl border border-green-700 py-2 z-50"
//                     >
//                       {updatesSubmenu.map((item) => (
//                         <Link
//                           key={item.name}
//                           to={item.path}
//                           className="flex items-center space-x-3 px-4 py-3 text-gray-300 hover:text-green-400 hover:bg-green-700/50 transition-colors duration-200"
//                           onClick={closeAllMenus}
//                         >
//                           {item.icon}
//                           <span>{item.name}</span>
//                         </Link>
//                       ))}
//                     </motion.div>
//                   )}
//                 </AnimatePresence>
//               </div>
//             </div>

//             {/* CTA Button */}
//             <div className="flex items-center space-x-4">
//               <motion.button
//                 whileHover={{ scale: 1.05 }}
//                 whileTap={{ scale: 0.95 }}
//                 onClick={() => navigate("/contact")}
//                 className="hidden sm:flex items-center space-x-2 px-6 py-2 bg-gradient-to-r from-green-500 to-emerald-500 rounded-2xl text-white font-semibold text-sm"
//               >
//                 <span>Get Consultation</span>
//               </motion.button>

//               {/* Mobile Menu Button */}
//               <motion.button
//                 whileHover={{ scale: 1.1 }}
//                 whileTap={{ scale: 0.9 }}
//                 onClick={() => setIsMenuOpen(!isMenuOpen)}
//                 className="md:hidden p-2 text-gray-300 hover:text-green-400 transition-colors"
//               >
//                 {isMenuOpen ? (
//                   <FiX className="w-6 h-6" />
//                 ) : (
//                   <FiMenu className="w-6 h-6" />
//                 )}
//               </motion.button>
//             </div>
//           </div>
//         </div>

//         {/* Mobile Menu */}
//         <AnimatePresence>
//           {isMenuOpen && (
//             <motion.div
//               initial={{ opacity: 0, height: 0 }}
//               animate={{ opacity: 1, height: "auto" }}
//               exit={{ opacity: 0, height: 0 }}
//               className="md:hidden bg-green-800/95 backdrop-blur-lg border-t border-green-700 overflow-y-auto max-h-[80vh]"
//             >
//               <div className="px-4 py-4 space-y-2">
//                 {menuItems.map((item) => (
//                   <Link
//                     key={item.name}
//                     to={item.path}
//                     onClick={closeAllMenus}
//                     className="flex items-center space-x-3 text-gray-300 hover:text-green-400 transition-colors duration-300 font-medium py-2 px-2 rounded-lg hover:bg-green-700/50"
//                   >
//                     {item.icon}
//                     <span>{item.name}</span>
//                   </Link>
//                 ))}

//                 {/* Mobile About Accordion */}
//                 <div className="border-t border-green-700 pt-4 mt-2">
//                   <button
//                     onClick={() => toggleMobileSection("about")}
//                     className="flex items-center justify-between w-full text-green-400 font-semibold mb-2 py-2 px-2 rounded-lg hover:bg-green-700/50 transition-colors"
//                   >
//                     <div className="flex items-center space-x-3">
//                       <FiInfo className="w-5 h-5" />
//                       <span>About</span>
//                     </div>
//                     <FiChevronDown
//                       className={`w-4 h-4 transition-transform duration-200 ${
//                         mobileOpenSections.about ? "rotate-180" : ""
//                       }`}
//                     />
//                   </button>

//                   <AnimatePresence>
//                     {mobileOpenSections.about && (
//                       <motion.div
//                         initial={{ opacity: 0, height: 0 }}
//                         animate={{ opacity: 1, height: "auto" }}
//                         exit={{ opacity: 0, height: 0 }}
//                         className="ml-4 space-y-1 overflow-hidden"
//                       >
//                         {aboutSubmenu.map((item) => (
//                           <Link
//                             key={item.name}
//                             to={item.path}
//                             onClick={closeAllMenus}
//                             className="flex items-center space-x-3 text-gray-300 hover:text-green-400 transition-colors duration-300 font-medium py-2 px-3 rounded-lg hover:bg-green-700/50"
//                           >
//                             {item.icon}
//                             <span className="text-sm">{item.name}</span>
//                           </Link>
//                         ))}
//                       </motion.div>
//                     )}
//                   </AnimatePresence>
//                 </div>

//                 {/* Mobile Team Accordion */}
//                 <div className="border-t border-green-700 pt-4">
//                   <button
//                     onClick={() => toggleMobileSection("team")}
//                     className="flex items-center justify-between w-full text-green-400 font-semibold mb-2 py-2 px-2 rounded-lg hover:bg-green-700/50 transition-colors"
//                   >
//                     <div className="flex items-center space-x-3">
//                       <FiUsers className="w-5 h-5" />
//                       <span>Team</span>
//                     </div>
//                     <FiChevronDown
//                       className={`w-4 h-4 transition-transform duration-200 ${
//                         mobileOpenSections.team ? "rotate-180" : ""
//                       }`}
//                     />
//                   </button>

//                   <AnimatePresence>
//                     {mobileOpenSections.team && (
//                       <motion.div
//                         initial={{ opacity: 0, height: 0 }}
//                         animate={{ opacity: 1, height: "auto" }}
//                         exit={{ opacity: 0, height: 0 }}
//                         className="ml-4 space-y-1 overflow-hidden"
//                       >
//                         {teamSubmenu.map((item) => (
//                           <Link
//                             key={item.name}
//                             to={item.path}
//                             onClick={closeAllMenus}
//                             className="flex items-center space-x-3 text-gray-300 hover:text-green-400 transition-colors duration-300 font-medium py-2 px-3 rounded-lg hover:bg-green-700/50"
//                           >
//                             {item.icon}
//                             <span className="text-sm">{item.name}</span>
//                           </Link>
//                         ))}
//                       </motion.div>
//                     )}
//                   </AnimatePresence>
//                 </div>

//                 {/* Mobile Updates Accordion */}
//                 <div className="border-t border-green-700 pt-4">
//                   <button
//                     onClick={() => toggleMobileSection("updates")}
//                     className="flex items-center justify-between w-full text-green-400 font-semibold mb-2 py-2 px-2 rounded-lg hover:bg-green-700/50 transition-colors"
//                   >
//                     <div className="flex items-center space-x-3">
//                       <FiAward className="w-5 h-5" />
//                       <span>Updates</span>
//                     </div>
//                     <FiChevronDown
//                       className={`w-4 h-4 transition-transform duration-200 ${
//                         mobileOpenSections.updates ? "rotate-180" : ""
//                       }`}
//                     />
//                   </button>

//                   <AnimatePresence>
//                     {mobileOpenSections.updates && (
//                       <motion.div
//                         initial={{ opacity: 0, height: 0 }}
//                         animate={{ opacity: 1, height: "auto" }}
//                         exit={{ opacity: 0, height: 0 }}
//                         className="ml-4 space-y-1 overflow-hidden"
//                       >
//                         {updatesSubmenu.map((item) => (
//                           <Link
//                             key={item.name}
//                             to={item.path}
//                             onClick={closeAllMenus}
//                             className="flex items-center space-x-3 text-gray-300 hover:text-green-400 transition-colors duration-300 font-medium py-2 px-3 rounded-lg hover:bg-green-700/50"
//                           >
//                             {item.icon}
//                             <span className="text-sm">{item.name}</span>
//                           </Link>
//                         ))}
//                       </motion.div>
//                     )}
//                   </AnimatePresence>
//                 </div>

//                 {/* Mobile CTA Button */}
//                 <div className="border-t border-green-700 pt-4">
//                   <button
//                     onClick={() => {
//                       navigate("/contact");
//                       closeAllMenus();
//                     }}
//                     className="w-full flex items-center justify-center space-x-2 px-4 py-3 bg-gradient-to-r from-green-500 to-emerald-500 rounded-2xl text-white font-semibold text-sm mt-2"
//                   >
//                     <span>Get Consultation</span>
//                   </button>
//                 </div>
//               </div>
//             </motion.div>
//           )}
//         </AnimatePresence>
//       </nav>

//       {/* Spacer for fixed navbar */}
//       <div className="h-16"></div>
//     </>
//   );
// }

// export default Navbar;

// src/components/Navbar.jsx
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import {
  FiMenu,
  FiX,
  FiHome,
  FiInfo,
  FiMail,
  FiBriefcase,
  FiUsers,
  FiAward,
  FiImage,
  FiStar,
  FiCpu,
  FiChevronDown,
  FiBookOpen,
  FiGlobe,
  FiUser,
  FiLogIn,
} from "react-icons/fi";

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAboutHovered, setIsAboutHovered] = useState(false);
  const [isTeamHovered, setIsTeamHovered] = useState(false);
  const [isUpdatesHovered, setIsUpdatesHovered] = useState(false);
  const [mobileOpenSections, setMobileOpenSections] = useState({
    about: false,
    team: false,
    updates: false,
  });
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { name: "Home", path: "/", icon: <FiHome className="w-5 h-5" /> },
    {
      name: "Services",
      path: "/services",
      icon: <FiBriefcase className="w-5 h-5" />,
    },
    { name: "Contact", path: "/contact", icon: <FiMail className="w-5 h-5" /> },
  ];

  const aboutSubmenu = [
    {
      name: "Company Overview",
      path: "/about",
      icon: <FiInfo className="w-4 h-4" />,
    },
    {
      name: "Technology",
      path: "/technology",
      icon: <FiCpu className="w-4 h-4" />,
    },
    {
      name: "Testimonials",
      path: "/testimonials",
      icon: <FiStar className="w-4 h-4" />,
    },
    {
      name: "Gallery",
      path: "/gallery",
      icon: <FiImage className="w-4 h-4" />,
    },
  ];

  const teamSubmenu = [
    {
      name: "Management Team",
      path: "/team/management",
      icon: <FiUsers className="w-4 h-4" />,
    },
    {
      name: "Consultancy Team",
      path: "/team/consultancy",
      icon: <FiUsers className="w-4 h-4" />,
    },
    { name: "All Team", path: "/team", icon: <FiUsers className="w-4 h-4" /> },
  ];

  const updatesSubmenu = [
    {
      name: "Projects",
      path: "/projects",
      icon: <FiAward className="w-4 h-4" />,
    },
    {
      name: "News",
      path: "/news",
      icon: <FiGlobe className="w-4 h-4" />,
    },
    {
      name: "Blog",
      path: "/blog",
      icon: <FiBookOpen className="w-4 h-4" />,
    },
  ];

  const closeAllMenus = () => {
    setIsMenuOpen(false);
    setIsAboutHovered(false);
    setIsTeamHovered(false);
    setIsUpdatesHovered(false);
    setMobileOpenSections({
      about: false,
      team: false,
      updates: false,
    });
  };

  const toggleMobileSection = (section) => {
    setMobileOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  useEffect(() => {
    closeAllMenus();
  }, [location]);

  return (
    <>
      <nav className="fixed top-0 w-full z-50 bg-green-900/95 backdrop-blur-lg border-b border-green-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="flex items-center space-x-3 cursor-pointer"
              onClick={() => navigate("/")}
            >
              <div className="w-10 h-10 bg-gradient-to-r from-green-500 to-emerald-500 rounded-xl flex items-center justify-center">
                <span className="text-white font-bold text-lg">A</span>
              </div>
              <span className="text-white font-bold text-xl bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent">
                Afrikonsults
              </span>
            </motion.div>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-6">
              {menuItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className="text-gray-300 hover:text-green-400 transition-colors duration-300 font-medium flex items-center space-x-1"
                >
                  {item.icon}
                  <span>{item.name}</span>
                </Link>
              ))}

              {/* About Dropdown */}
              <div
                className="relative"
                onMouseEnter={() => setIsAboutHovered(true)}
                onMouseLeave={() => setIsAboutHovered(false)}
              >
                <button className="text-gray-300 hover:text-green-400 transition-colors duration-300 font-medium flex items-center space-x-1">
                  <FiInfo className="w-5 h-5" />
                  <span>About</span>
                  <FiChevronDown
                    className={`w-4 h-4 transition-transform duration-200 ${
                      isAboutHovered ? "rotate-180" : ""
                    }`}
                  />
                </button>

                <AnimatePresence>
                  {isAboutHovered && (
                    <motion.div
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: 10 }}
                      className="absolute top-full left-0 mt-2 w-56 bg-green-800/95 backdrop-blur-lg rounded-xl shadow-xl border border-green-700 py-2 z-50"
                    >
                      {aboutSubmenu.map((item) => (
                        <Link
                          key={item.name}
                          to={item.path}
                          className="flex items-center space-x-3 px-4 py-3 text-gray-300 hover:text-green-400 hover:bg-green-700/50 transition-colors duration-200"
                          onClick={closeAllMenus}
                        >
                          {item.icon}
                          <span>{item.name}</span>
                        </Link>
                      ))}
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>

              {/* Team Dropdown */}
              <div
                className="relative"
                onMouseEnter={() => setIsTeamHovered(true)}
                onMouseLeave={() => setIsTeamHovered(false)}
              >
                <button className="text-gray-300 hover:text-green-400 transition-colors duration-300 font-medium flex items-center space-x-1">
                  <FiUsers className="w-5 h-5" />
                  <span>Team</span>
                  <FiChevronDown
                    className={`w-4 h-4 transition-transform duration-200 ${
                      isTeamHovered ? "rotate-180" : ""
                    }`}
                  />
                </button>

                <AnimatePresence>
                  {isTeamHovered && (
                    <motion.div
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: 10 }}
                      className="absolute top-full left-0 mt-2 w-64 bg-green-800/95 backdrop-blur-lg rounded-xl shadow-xl border border-green-700 py-2 z-50"
                    >
                      {teamSubmenu.map((item) => (
                        <Link
                          key={item.name}
                          to={item.path}
                          className="flex items-center space-x-3 px-4 py-3 text-gray-300 hover:text-green-400 hover:bg-green-700/50 transition-colors duration-200"
                          onClick={closeAllMenus}
                        >
                          {item.icon}
                          <span>{item.name}</span>
                        </Link>
                      ))}
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>

              {/* Updates Dropdown */}
              <div
                className="relative"
                onMouseEnter={() => setIsUpdatesHovered(true)}
                onMouseLeave={() => setIsUpdatesHovered(false)}
              >
                <button className="text-gray-300 hover:text-green-400 transition-colors duration-300 font-medium flex items-center space-x-1">
                  <FiAward className="w-5 h-5" />
                  <span>Updates</span>
                  <FiChevronDown
                    className={`w-4 h-4 transition-transform duration-200 ${
                      isUpdatesHovered ? "rotate-180" : ""
                    }`}
                  />
                </button>

                <AnimatePresence>
                  {isUpdatesHovered && (
                    <motion.div
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: 10 }}
                      className="absolute top-full left-0 mt-2 w-56 bg-green-800/95 backdrop-blur-lg rounded-xl shadow-xl border border-green-700 py-2 z-50"
                    >
                      {updatesSubmenu.map((item) => (
                        <Link
                          key={item.name}
                          to={item.path}
                          className="flex items-center space-x-3 px-4 py-3 text-gray-300 hover:text-green-400 hover:bg-green-700/50 transition-colors duration-200"
                          onClick={closeAllMenus}
                        >
                          {item.icon}
                          <span>{item.name}</span>
                        </Link>
                      ))}
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>

              {/* Client Portal Link */}
              <Link
                to="/client-portal"
                className="text-gray-300 hover:text-green-400 transition-colors duration-300 font-medium flex items-center space-x-1 border-l border-green-700 pl-6"
              >
                <FiUser className="w-5 h-5" />
                <span>Client Portal</span>
              </Link>
            </div>

            {/* CTA Button */}
            <div className="flex items-center space-x-4">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => navigate("/contact")}
                className="hidden sm:flex items-center space-x-2 px-6 py-2 bg-gradient-to-r from-green-500 to-emerald-500 rounded-2xl text-white font-semibold text-sm"
              >
                <span>Get Consultation</span>
              </motion.button>

              {/* Mobile Menu Button */}
              <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="md:hidden p-2 text-gray-300 hover:text-green-400 transition-colors"
              >
                {isMenuOpen ? (
                  <FiX className="w-6 h-6" />
                ) : (
                  <FiMenu className="w-6 h-6" />
                )}
              </motion.button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        <AnimatePresence>
          {isMenuOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              className="md:hidden bg-green-800/95 backdrop-blur-lg border-t border-green-700 overflow-y-auto max-h-[80vh]"
            >
              <div className="px-4 py-4 space-y-2">
                {menuItems.map((item) => (
                  <Link
                    key={item.name}
                    to={item.path}
                    onClick={closeAllMenus}
                    className="flex items-center space-x-3 text-gray-300 hover:text-green-400 transition-colors duration-300 font-medium py-2 px-2 rounded-lg hover:bg-green-700/50"
                  >
                    {item.icon}
                    <span>{item.name}</span>
                  </Link>
                ))}

                {/* Client Portal Mobile Link */}
                <Link
                  to="/client-portal"
                  onClick={closeAllMenus}
                  className="flex items-center space-x-3 text-gray-300 hover:text-green-400 transition-colors duration-300 font-medium py-2 px-2 rounded-lg hover:bg-green-700/50 border-t border-green-700 pt-4"
                >
                  <FiUser className="w-5 h-5" />
                  <span>Client Portal</span>
                </Link>

                {/* Mobile About Accordion */}
                <div className="border-t border-green-700 pt-4 mt-2">
                  <button
                    onClick={() => toggleMobileSection("about")}
                    className="flex items-center justify-between w-full text-green-400 font-semibold mb-2 py-2 px-2 rounded-lg hover:bg-green-700/50 transition-colors"
                  >
                    <div className="flex items-center space-x-3">
                      <FiInfo className="w-5 h-5" />
                      <span>About</span>
                    </div>
                    <FiChevronDown
                      className={`w-4 h-4 transition-transform duration-200 ${
                        mobileOpenSections.about ? "rotate-180" : ""
                      }`}
                    />
                  </button>

                  <AnimatePresence>
                    {mobileOpenSections.about && (
                      <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        className="ml-4 space-y-1 overflow-hidden"
                      >
                        {aboutSubmenu.map((item) => (
                          <Link
                            key={item.name}
                            to={item.path}
                            onClick={closeAllMenus}
                            className="flex items-center space-x-3 text-gray-300 hover:text-green-400 transition-colors duration-300 font-medium py-2 px-3 rounded-lg hover:bg-green-700/50"
                          >
                            {item.icon}
                            <span className="text-sm">{item.name}</span>
                          </Link>
                        ))}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>

                {/* Mobile Team Accordion */}
                <div className="border-t border-green-700 pt-4">
                  <button
                    onClick={() => toggleMobileSection("team")}
                    className="flex items-center justify-between w-full text-green-400 font-semibold mb-2 py-2 px-2 rounded-lg hover:bg-green-700/50 transition-colors"
                  >
                    <div className="flex items-center space-x-3">
                      <FiUsers className="w-5 h-5" />
                      <span>Team</span>
                    </div>
                    <FiChevronDown
                      className={`w-4 h-4 transition-transform duration-200 ${
                        mobileOpenSections.team ? "rotate-180" : ""
                      }`}
                    />
                  </button>

                  <AnimatePresence>
                    {mobileOpenSections.team && (
                      <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        className="ml-4 space-y-1 overflow-hidden"
                      >
                        {teamSubmenu.map((item) => (
                          <Link
                            key={item.name}
                            to={item.path}
                            onClick={closeAllMenus}
                            className="flex items-center space-x-3 text-gray-300 hover:text-green-400 transition-colors duration-300 font-medium py-2 px-3 rounded-lg hover:bg-green-700/50"
                          >
                            {item.icon}
                            <span className="text-sm">{item.name}</span>
                          </Link>
                        ))}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>

                {/* Mobile Updates Accordion */}
                <div className="border-t border-green-700 pt-4">
                  <button
                    onClick={() => toggleMobileSection("updates")}
                    className="flex items-center justify-between w-full text-green-400 font-semibold mb-2 py-2 px-2 rounded-lg hover:bg-green-700/50 transition-colors"
                  >
                    <div className="flex items-center space-x-3">
                      <FiAward className="w-5 h-5" />
                      <span>Updates</span>
                    </div>
                    <FiChevronDown
                      className={`w-4 h-4 transition-transform duration-200 ${
                        mobileOpenSections.updates ? "rotate-180" : ""
                      }`}
                    />
                  </button>

                  <AnimatePresence>
                    {mobileOpenSections.updates && (
                      <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        className="ml-4 space-y-1 overflow-hidden"
                      >
                        {updatesSubmenu.map((item) => (
                          <Link
                            key={item.name}
                            to={item.path}
                            onClick={closeAllMenus}
                            className="flex items-center space-x-3 text-gray-300 hover:text-green-400 transition-colors duration-300 font-medium py-2 px-3 rounded-lg hover:bg-green-700/50"
                          >
                            {item.icon}
                            <span className="text-sm">{item.name}</span>
                          </Link>
                        ))}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>

                {/* Mobile CTA Button */}
                <div className="border-t border-green-700 pt-4">
                  <button
                    onClick={() => {
                      navigate("/contact");
                      closeAllMenus();
                    }}
                    className="w-full flex items-center justify-center space-x-2 px-4 py-3 bg-gradient-to-r from-green-500 to-emerald-500 rounded-2xl text-white font-semibold text-sm mt-2"
                  >
                    <span>Get Consultation</span>
                  </button>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </nav>

      {/* Spacer for fixed navbar */}
      <div className="h-16"></div>
    </>
  );
}

export default Navbar;
